import type { MediaStatus } from "./types";

export const statusLabel: Record<MediaStatus, string> = {
  pending: "Pending Review",
  approved: "Approved",
  hidden: "Hidden / Private",
  not_approved: "Not Approved",
  deleted: "Deleted",
};

export const statusClass = (status: MediaStatus, featured?: boolean) => {
  if (featured && status === "approved") return "status-featured";
  if (status === "pending") return "status-pending";
  if (status === "approved") return "status-approved";
  if (status === "hidden") return "status-hidden";
  if (status === "not_approved") return "status-not-approved";
  return "status-deleted";
};

export const formatBytes = (bytes = 0) => {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** index).toFixed(index === 0 ? 0 : 1)} ${units[index]}`;
};

export const formatDate = (value?: string) => {
  if (!value) return "Not set";
  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(new Date(value));
};

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "K";

export const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, "");
